// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Nru0","colMin":"styles_colMin__1MzWC"};